import { overdueSupplierCount } from '@/api/tool/gen/second_phase'
export const useBadgeStore = defineStore('badge', () => {
  const badgeCount = ref<number>(0); // 徽章数
  const intervalId = ref<any>(null) // 用于clearInterval

  /**
   * 请求供应商徽章数
   * @param 
   * @returns
   */
  const getBadgeCount = async () => {
    let res = await overdueSupplierCount()
    if(res.code === 200) badgeCount.value = res.data
  };

  /**
   * 创建定时任务更新
   * @param 
   * @returns
   */
  const setBadgeInterval = async () => {
    clearBadgeInterval()
    getBadgeCount()
    intervalId.value = setInterval(() => {
        getBadgeCount()
    },1000 * 60 * 5)
  };

  /**
   * 清除定时任务
   * @param 
   * @returns
   */
  const clearBadgeInterval = () : boolean => {
    try{
        if(intervalId.value) {
            clearInterval(intervalId.value)
            intervalId.value = null
        }
        return true
    } catch {
        return false
    }
  };

  return {
    badgeCount,
    intervalId,
    getBadgeCount,
    setBadgeInterval,
    clearBadgeInterval
  };
});

export default useBadgeStore;
